module.exports = __webpack_public_path__ + "static/img/file-audio.5083689b.svg";